import { helper } from '@ember/component/helper';
import { htmlSafe } from '@ember/template';
import { SafeString } from 'handlebars';

export default helper(function ([slug]: [string]): SafeString {
  return htmlSafe(slug);
});
